import React from "react";

const Tooltip = ({
  infoLogo,
  children,
  ariaLabel = "information",
  tooltipClass = "",
}) => {
  return (
    <div className={`tooltip-button-wrapper ${tooltipClass}`}>
      <button
        type="button"
        className="info-button"
        aria-describedby="tooltip-save"
        aria-label={ariaLabel}
      >
        <img className="money_info money-info-image" src={infoLogo} alt="" />
      </button>

      <div id="tooltip-save" role="tooltip" className={`tool focus-tooltip`}>
        {children}
      </div>
    </div>
  );
};

export default Tooltip;
